import {CommonErrorModal} from "@app/components/modals/CommonErrorModal"
import { navigate } from "@app/router";
import {useModal} from "@shortsworks/ui"

import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Path } from "@app/route_path";
import { getAuthToken, useAuthToken } from "@shortsworks/user-api";

export const AuthLayout = () => {
  const {showModal} = useModal();
  const { pathname } = useLocation();
  const [tokens] = useAuthToken();

  useEffect(() => {
      if (!tokens) {
        navigate(
            {
              path: Path.LOGIN,
            },
            {
              state: pathname,
            },
        );
        return;
      }
  }, [tokens]);

  return <Outlet />;
};
